import { BrowserLevel } from 'browser-level';
import { LevelClient } from './cache/level';

export function createLevelClient(db) {
  return new LevelClient(db);
}

const cache = createLevelClient(
  new BrowserLevel('cache', { valueEncoding: 'json' })
);

export default cache;
